import {fetchPost, fetchGet} from './https';
export default {
    host: apiHost.host,
    host2: apiHost.host2,
    getConfig() {
        return fetchGet(this.host + '/config/isopen')
    },

    loginApi(trade_account, pwd) {
        return fetchPost(this.host + 'stockclient/login', {trade_account, pwd});
    },

    /**
     * 搜索股票
     */
    searchGp(content, token, trade_account) {
        return fetchPost(this.host + 'zxclient/searchstock', {content, token, trade_account});
    },

    /**
     * 我的自选 http://xx.com/zxclient/mychoosestock
     */
    mychoosestock(token, trade_account) {
        return fetchPost(this.host + 'zxclient/mychoosestock', {token, trade_account});
    },

    /**
     * 查看交易账户的详情资产信息
     * http://xx.com/stockclient/accountinfo
     */
    accountinfo(token, trade_account) {
        return fetchPost(this.host + 'stockclient/accountinfo', {token, trade_account});
    },

    /**
     * 查看账户可用资金
     * http://xx.com/stockclient/tradeaccountmoney
     */
    tradeaccountmoney(token, trade_account) {
        return fetchPost(this.host + 'stockclient/tradeaccountmoney', {token, trade_account});
    },

    /**
     * 查看某个账户的某只股票的可卖数量
     * http://xx.com/stockclient/stockdetail
     */
    stockdetail(stock_code, token, trade_account) {
        return fetchPost(this.host + 'stockclient/cansell', {stock_code, token, trade_account});
    },

    /**
     * 修改交易账户密码
     */
    setpasswd(pwd, new_pwd, token, trade_account) {
        return fetchPost(this.host + 'stockclient/setpasswd', {pwd, new_pwd, token, trade_account});
    },

    /**
     * 查看持仓中的策略 checkstrategy
     */
    checkstrategy(token, trade_account) {
        return fetchPost(this.host + 'stockclient/checkstrategy', {token, trade_account});
    },

    /**
     * 查询撤单的策略（委托） chedanstrategy
     */
    chedanstrategy(token, trade_account) {
        return fetchPost(this.host + 'stockclient/chedanstrategy', {token, trade_account});
    },

    /**
     * 查询撤单的策略（委托） chedanstrategy
     */
    canchedan(token, trade_account) {
        return fetchPost(this.host + 'stockclient/canchedan', {token, trade_account});
    },

    /**
     * 今日委托（委托） todayentrust
     */
    todayentrust(token, trade_account) {
        return fetchPost(this.host + 'stockclient/todayentrust', {token, trade_account});
    },
    /**
     * 历史委托（委托） allentrust
     */
    allentrust(token, trade_account, begin_time, end_time) {
        return fetchPost(this.host + 'stockclient/allentrust', {token, trade_account, begin_time, end_time});
    },

    /**
     * 查询股票的交易记录（委托） checkstrategyhistory , begin_time, end_time 这两个是可选
     */
    checkstrategyhistory(token, trade_account, begin_time, end_time) {
        return fetchPost(this.host + 'stockclient/checkstrategyhistory', {token, trade_account, begin_time, end_time});
    },

    /**
     * 添加我的自选 http://xx.com/zxclient/addchoosestock
     */
    addChooseStock(token, trade_account, stock_code, stock_name) {
        return fetchPost(this.host + 'zxclient/addchoosestock', {token, trade_account, stock_code, stock_name});
    },
    /**
     * 删除我的自选 http://xx.com/zxclient/deletechoosestock
     */
    deleteChooseStock(token, trade_account, stock_code) {
        return fetchPost(this.host + 'zxclient/deletechoosestock', {token, trade_account, stock_code});
    },
    /**
     * 判断是不是自己的自选 http://xx.com/zxclient/judgechoosestock
     */
    judgeChooseCtock(token, trade_account, stock_code) {
        return fetchPost(this.host + 'zxclient/judgechoosestock', {token, trade_account, stock_code});
    },
    /**
     * 节假日 正常 为 1
     * @returns {*|Promise|Promise<unknown>}
     */
    openquota(token, trade_account) {
        return fetchPost(this.host + 'stockclient/openquota', {token, trade_account});
    },
    /**
     * 买入股票
     * @returns {*|Promise|Promise<unknown>}
     */
    createstrategy(token, trade_account, stock_code, stock_number, buy_price, buy_type) {
        return fetchPost(this.host + 'stockclient/createstrategy',{token, trade_account, stock_code, stock_number, buy_price, buy_type});
    },
    /**
     * 买入股票
     * @returns {*|Promise|Promise<unknown>}
     */
    shellstrategy(token, trade_account, stock_code, stock_number, sell_price, sell_type) {
        return fetchPost(this.host + 'stockclient/shellstrategy',{token, trade_account, stock_code, stock_number, sell_price, sell_type});
    },
    /**
     * 申请撤单
     * @returns {*|Promise|Promise<unknown>}
     */
    cancelorder(token, trade_account, cancel_type, id) {
        return fetchPost(this.host + 'stockclient/cancelorder',{token, trade_account, cancel_type, id});
    },

    // host2 行情接口
    /**
     * 指定获取某个板块股票列表
     * @param type 板块类型
     */
    getGpList(type) {
        return fetchPost(this.host2 + 'app/client.php', {fun: 'getallstock', type});
    },

    /**
     * 获取大盘指数
     * http://app.giyyj.cn/app/client.php?fun=getDapan
     */
    getDapan() {
        return fetchPost(this.host2 + 'app/client.php', {fun: 'getDapan'});
    },

    /**
     * 获取某一只股票行情
     * @param code 股票号码
     * http://app.giyyj.cn/app/client.php?fun=market&stockCode=sh600000
     */
    getGpDetail(stockCode) {
        return fetchPost(this.host2 + 'app/client.php', {fun: 'market', stockCode});
    },

    /**
     * http://app.giyyj.cn/app/pushClient.php?stockCode=股票代码&mid=登录uid
     */
    senUid(stockCode, mid) {
        return fetchPost(this.host2 + 'app/pushClient.php', {stockCode, mid});
    },

    /**
     * 分时，日K，周K，月K
     * minute分时，day日K，week周K,month月K
     */
    getMinuteOrKLine(fun, stockCode) {
        return fetchPost(this.host2 + 'app/client.php', {fun, stockCode});
    },



}
